import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';

import { DeviceStoreActions, LocationSubset } from '@era/stores';
import { PaneComponent } from '@rocksoft/cdk';
import { ModelNameFlags } from '@rocksoft/locations-sdk';
import { ModelNamesFilter } from './model-names-filter';
import { RebootDevicesModalComponent } from './reboot-devices-modal.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-reboot-devices-modal',
  templateUrl: './reboot-devices-modal.container.html',
  imports: [PaneComponent, RebootDevicesModalComponent],
})
export class RebootDevicesModalContainerComponent {
  public readonly activeModal = inject(NgbActiveModal);
  private readonly store = inject(Store);

  public readonly rebootDevicesForm: UntypedFormGroup;
  public locationSubset = LocationSubset.All;
  private readonly modelNames = new Array<ModelNameFlags>();

  closeModal() {
    this.activeModal.close();
  }

  rebootDevices(modelNamesFilter: ModelNamesFilter) {
    Object.keys(modelNamesFilter).forEach((propertyName) => {
      if (modelNamesFilter[propertyName] === true) {
        this.modelNames.push(propertyName as ModelNameFlags);
      }
    });

    this.store.dispatch(
      DeviceStoreActions.DeviceModalActions.rebootDevicesRequested({
        locationSubset: this.locationSubset,
        modelNames: new Set(this.modelNames),
      })
    );

    this.activeModal.close();
  }
}
